import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourSeguridadPermisos: TourDefinicion = {
  codigo: 'seguridad-permisos',
  titulo: 'Permisos',
  descripcion: 'Catálogo de solo lectura con todos los permisos del sistema.',
  ruta: '/admin/seguridad/permisos',
  permisoMenu: Permisos.PERMISOS_MENU,
  pasos: [
    {
      id: 'seguridad-permisos:header',
      selector: '[data-testid="seguridad-permisos.header"]',
      titulo: 'Permisos',
      descripcion:
        'Catálogo completo de permisos. Son la unidad mínima de autorización; se asignan a los roles, no a los usuarios.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'seguridad-permisos:tabla',
      selector: '[data-testid="seguridad-permisos.tabla"]',
      titulo: 'Listado',
      descripcion:
        'Esta pantalla es de solo lectura. Para modificar qué puede hacer un usuario, asigna o revoca permisos al rol correspondiente.',
      side: 'top',
      align: 'center',
    },
  ],
};
